function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M96.875 60.7736H1.52813C1.33048 60.7752 1.13449 60.7371 0.951574 60.6616C0.768661 60.5861 0.602482 60.4747 0.462717 60.3338C0.322953 60.193 0.212399 60.0255 0.137493 59.8411C0.062587 59.6568 0.0248276 59.4592 0.0264153 59.26V57.6504H98.2575V59.3802C98.2575 59.7497 98.1119 60.1041 97.8526 60.3655C97.5933 60.6268 97.2417 60.7736 96.875 60.7736Z",
  fill: "#CCCCCC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.2483 1H16.7104C12.8005 1 9.63086 4.19455 9.63086 8.13522V42.3098C9.63086 46.2505 12.8005 49.445 16.7104 49.445H81.2483C85.1582 49.445 88.3278 46.2505 88.3278 42.3098V8.13522C88.3278 4.19455 85.1582 1 81.2483 1Z",
  fill: "#E6E6E6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7764 2.94727H14.2089C12.9714 2.94727 11.9683 3.95834 11.9683 5.20555V44.3172C11.9683 45.5644 12.9714 46.5754 14.2089 46.5754H83.7764C85.0138 46.5754 86.017 45.5644 86.017 44.3172V5.20555C86.017 3.95834 85.0138 2.94727 83.7764 2.94727Z",
  fill: "#0E3163"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M96.8032 59.2103H1.45633C1.1799 59.2107 0.909082 59.1317 0.675607 58.9826C0.442133 58.8334 0.255678 58.6203 0.138098 58.3681C0.0205186 58.116 -0.0233129 57.8353 0.0117378 57.559C0.0467885 57.2826 0.15927 57.022 0.336 56.8078L9.63232 45.5645H88.2935L97.8281 56.8078C98.0005 57.0157 98.1124 57.2677 98.1512 57.5358C98.1901 57.8039 98.1544 58.0776 98.0482 58.3265C97.9421 58.5754 97.7695 58.7898 97.5497 58.9458C97.3299 59.1018 97.0715 59.1934 96.8032 59.2103Z",
  fill: "#E6E6E6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0503 33.2792L56.1646 16.4941M40.0251 33.2792L67.1394 16.4941",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M110.11 13.0842V7.18626C110.107 5.54654 109.459 3.97488 108.309 2.81542C107.159 1.65596 105.599 1.00317 103.972 1V1C102.487 1.01129 101.055 1.56536 99.9441 2.5594C98.8329 3.55344 98.1172 4.91997 97.9297 6.40547V6.40547C97.8921 6.66405 97.8722 6.92493 97.8701 7.18626V7.18626V13.0842",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M80.0537 32.4463V80.9995H127.882V32.4463C127.884 29.2809 127.266 26.1462 126.066 23.2213C124.865 20.2964 123.104 17.6386 120.884 15.3998C118.664 13.161 116.027 11.385 113.126 10.1733C110.224 8.96156 107.115 8.33789 103.974 8.33789C98.1631 8.33891 92.5515 10.4717 88.1869 14.3379C83.8223 18.2041 81.0033 23.5393 80.2563 29.3472V29.4072C80.1275 30.4152 80.0598 31.4301 80.0537 32.4463Z",
  fill: "#1F75DB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M117.836 52.9043H90.1015C87.7516 52.9043 85.8467 54.8243 85.8467 57.1926V70.394C85.8467 72.7624 87.7516 74.6824 90.1015 74.6824H117.836C120.185 74.6824 122.09 72.7624 122.09 70.394V57.1926C122.09 54.8243 120.185 52.9043 117.836 52.9043Z",
  fill: "#1B4D89"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M120.993 49.3926H86.9421C85.5664 49.3926 84.4512 50.5166 84.4512 51.9031V52.5037C84.4512 53.8903 85.5664 55.0143 86.9421 55.0143H120.993C122.369 55.0143 123.484 53.8903 123.484 52.5037V51.9031C123.484 50.5166 122.369 49.3926 120.993 49.3926Z",
  fill: "white"
});

function SvgPackM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 81,
    viewBox: "0 0 160 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = React.forwardRef(SvgPackM);
export default __webpack_public_path__ + "static/media/pack-m.63a773ca.svg";
export { ForwardRef as ReactComponent };